// RAF-driven count-up with a cubic ease-out, shared by the stamp reward reveal
// and the Boosting Pack reward queue. Rounds to whole numbers each frame (the
// pills only ever show integers) and fires onDone once when it settles. A
// delta <= 0 is a no-op that still resolves via onDone so callers can clear
// their "animating" guard uniformly.
export function animateCount(opts: {
  from: number
  delta: number
  duration?: number
  onTick: (value: number) => void
  onDone?: () => void
}) {
  const { from, delta, duration = 700, onTick, onDone } = opts
  if (delta <= 0) {
    onDone?.()
    return
  }
  const to = from + delta
  const start = performance.now()
  const tick = (now: number) => {
    const t = Math.min(1, (now - start) / duration)
    const eased = 1 - Math.pow(1 - t, 3)
    onTick(Math.round(from + (to - from) * eased))
    if (t < 1) {
      requestAnimationFrame(tick)
    } else {
      onDone?.()
    }
  }
  requestAnimationFrame(tick)
}
